import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollToTop from "./components/ScrollToTop";
import DynamicFavicon from "./components/DynamicFavicon";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <DynamicFavicon />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
